import { useAppSelector } from '../../../../../../store/hooks';
import { getHasFormErrorSelector } from '../../selectors/get-has-form-error.selector';

export const useGetHasErrorStateSelector = (): boolean => {
  return useAppSelector(getHasFormErrorSelector);
};
